import { CalendarData, CalendarEvent, GetVoidCalendarData } from "../../interfaces/EspolAds/CalendarData";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { useState } from "react";
import esLocale from '@fullcalendar/core/locales/es';
import { Container } from "@mui/material";
import { ModalAnuncio } from "./ModalAnuncioBody";

interface Props{
    anuncios: Array<CalendarData>,
    events: Array<CalendarEvent>
}

export default function Calendar(props:Props) {
    const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null);
    const [selectedAnuncio, setSelectedAnuncio] = useState<CalendarData>(GetVoidCalendarData);
    let [open,setOpen] = useState(false);

    const abrirModal = () => {
        setOpen(true);
      };
    
      const cerrarModal = () => {
        setOpen(false);
      };

    const handleEventClick = (info: any) => {
        //console.log(info.event);
        setSelectedEvent({
            idanuncio: info.event.idanuncio,
            title: info.event.title,
            start: info.event.start || null,
            end: info.event.end || null,
        });
        getAnuncio(info.event._def.extendedProps.idanuncio);
    };

    function getAnuncio(id:number){
        let anuncio:CalendarData = props.anuncios.find(x => x.idAnuncio === id) || GetVoidCalendarData();
        //console.log(anuncio);
        setSelectedAnuncio(anuncio);
        setOpen(true)
    }

    return(
       <Container>
        <h2>Calendario</h2>
        <div>
            <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin]}
            headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            events={props.events}
            eventClick={handleEventClick}
            locale={esLocale} //Español
            />
        </div>
        {/* {selectedEvent && (
        <div>
          <h3>Detalles del Evento</h3>
          <p>Título: {selectedEvent.title}</p>
          {selectedEvent.start && <p>Inicio: {selectedEvent.start.toString()}</p>}
          {selectedEvent.end && <p>Fin: {selectedEvent.end.toString()}</p>}
        </div>
        )} */}
        <ModalAnuncio isOpen={open} toggle={cerrarModal} anuncio={selectedAnuncio}/>
      </Container>
    );
}